import { Component } from '@angular/core';

@Component({
  selector: 'app-inovar-group',
  templateUrl: './inovar-group.component.html',
  styleUrls: ['./inovar-group.component.scss']
})
export class InovarGroupComponent {
}
